import React, { Fragment, useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import { Breadcrumbs } from '../../../AbstractElements';
import { Container } from 'reactstrap';
import DataGridView from './DataGridView';
import DataGridItemWiseView from './DataGridItemWiseView';
import './datagrid.scss';

const resolveInitialMode = (urlMode) => {
    if (urlMode === 'daily' || urlMode === 'item') return urlMode;
    const stored = localStorage.getItem('dataMode');
    if (stored === 'dailywise') return 'daily';
    return 'item';
};

const DataGrid = () => {
    const { t } = useTranslation();
    const [searchParams, setSearchParams] = useSearchParams();
    const [mode, setMode] = useState(() => resolveInitialMode(searchParams.get('mode')));

    const changeMode = useCallback((next) => {
        if (next === mode) return;
        setMode(next);
        localStorage.setItem('dataMode', next === 'daily' ? 'dailywise' : 'itemwise');
        const params = new URLSearchParams(searchParams);
        params.set('mode', next);
        ['start', 'end', 'page', 'preset', 'filter', 'sort', 'size'].forEach(k => params.delete(k));
        setSearchParams(params, { replace: true });
    }, [mode, searchParams, setSearchParams]);

    return (
        <Fragment>
            <Breadcrumbs parent={t('Data Grid')} title={t('Data Grid')} mainTitle={t('Data Grid')} />
            <Container fluid={true}>
                <div className="v3 dg-mode-toggle-wrap">
                    <div className="dg-mode-toggle" role="tablist" aria-label={t('Data grid mode')}>
                        <button
                            type="button"
                            role="tab"
                            aria-selected={mode === 'item'}
                            className={mode === 'item' ? 'active' : ''}
                            onClick={() => changeMode('item')}
                        >
                            {t('Item-wise')}
                        </button>
                        <button
                            type="button"
                            role="tab"
                            aria-selected={mode === 'daily'}
                            className={mode === 'daily' ? 'active' : ''}
                            onClick={() => changeMode('daily')}
                        >
                            {t('Daily-wise')}
                        </button>
                    </div>
                </div>
                {mode === 'daily' ? <DataGridView key="daily" /> : <DataGridItemWiseView key="item" />}
            </Container>
        </Fragment>
    );
};

export default DataGrid;
